// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-add:focus {
  border: 1px solid #3287FE;
}

@media (min-width: 768px) {
  .add-wrapper {
    justify-content: space-between !important;
    max-width: 500px;
  }
}
.button-border {
  height: 2rem;
  background-color: #f6f6f6;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/repeat/repeat.component.scss"],"names":[],"mappings":"AAGE;EACE,yBAAA;AAFJ;;AAMA;EACE;IACE,yCAAA;IACA,gBAAA;EAHF;AACF;AAMA;EACE,YAAA;EACA,yBAAA;AAJF","sourcesContent":["@use 'mssvariables' as *;\n\n.btn-add {\n  &:focus {\n    border: 1px solid theme-color('primary');\n  }\n}\n\n@media (min-width: 768px) {\n  .add-wrapper {\n    justify-content: space-between !important;\n    max-width: 500px;\n  }\n}\n\n.button-border {\n  height: 2rem;\n  background-color: theme-color('light');\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
